import FeedbackRepository from '@/repositories/feedback/FeedbackRepository.ts';
import { FeedbackForm, mapFeedbackFormToFormData } from '@/types/feedback';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useFeedbackRepository() {
    const feedbackRepository = new FeedbackRepository();

    function sendFeedback(form: FeedbackForm): Promise<void> {
        return feedbackRepository.sendFeedback(
            mapFeedbackFormToFormData(form),
        );
    }

    return {
        sendFeedback: sendFeedback,
    };
}
